// frontend/admin-portal/src/components/settings/sections/PaymentsSettings.jsx
import React from "react";
import SettingItem from "../items/SettingItem";
import TextInput from "../items/TextInput";
import SelectInput from "../items/SelectInput";
import ToggleSwitch from "../items/ToggleSwitch";

const ALL_METHODS = [
  "cash",
  "card",
  "bank_transfer",
  "credit",
  "zaincash",
  "fastpay",
];

export default function PaymentsSettings({ values = {}, onChange }) {
  const safeOnChange = typeof onChange === "function" ? onChange : () => {};

  const enabled = Array.isArray(values["payments.methods"])
    ? values["payments.methods"]
    : ["cash"];

  const toggle = (m) => {
    const next = enabled.includes(m)
      ? enabled.filter((x) => x !== m)
      : [...enabled, m];
    safeOnChange("payments.methods", next);
  };

  return (
    <div className="fh-settings-list">
      <SettingItem label="Enabled Payment Methods">
        <div className="d-flex flex-wrap gap-3">
          {ALL_METHODS.map((m) => (
            <label key={m} className="fh-checkbox">
              <input
                type="checkbox"
                checked={enabled.includes(m)}
                onChange={() => toggle(m)}
              />
              <span>{m.replace("_", " ")}</span>
            </label>
          ))}
        </div>
      </SettingItem>

      <SettingItem label="Default Payment Method">
        <SelectInput
          value={values["payments.defaultMethod"]}
          onChange={(v) => safeOnChange("payments.defaultMethod", v)}
          options={enabled.map((m) => ({
            value: m,
            label: m.replace("_", " "),
          }))}
        />
      </SettingItem>

      <SettingItem label="Require Reference Number">
        <ToggleSwitch
          checked={values["payments.requireReference"]}
          onChange={(v) => safeOnChange("payments.requireReference", v)}
        />
      </SettingItem>

      <SettingItem label="Auto-number Invoices">
        <ToggleSwitch
          checked={values["invoices.autoNumber"]}
          onChange={(v) => safeOnChange("invoices.autoNumber", v)}
        />
      </SettingItem>

      <SettingItem label="Invoice Number Format">
        <TextInput
          value={values["invoices.numberFormat"]}
          onChange={(v) => safeOnChange("invoices.numberFormat", v)}
        />
      </SettingItem>

      <SettingItem label="Invoice Due (days)">
        <TextInput
          type="number"
          value={values["invoices.dueDays"]}
          onChange={(v) => safeOnChange("invoices.dueDays", Number(v))}
        />
      </SettingItem>

      <SettingItem label="Max Discount (%)">
        <TextInput
          type="number"
          value={values["finance.discountsMaxPercent"]}
          onChange={(v) =>
            safeOnChange("finance.discountsMaxPercent", Number(v))
          }
        />
      </SettingItem>

      <SettingItem label="Allow Manual Discount">
        <ToggleSwitch
          checked={values["finance.discountsAllowManual"]}
          onChange={(v) => safeOnChange("finance.discountsAllowManual", v)}
        />
      </SettingItem>
    </div>
  );
}
